package hk.com.vr360_demo2.webapp.core.net

//業務錯誤的異常類
class ServiceException(val code: Int, message: String?) : Exception(message)